<template>
  <div>
    <el-dialog
      :title="`${title}受众群体`"
      :visible="createAudienceGroupDialogVisible"
      width="1200px"
      append-to-body
      :close-on-click-modal="false"
      @close="close"
      @opened="openInit"
    >
      <el-form
        :model="form"
        label-width="200px"
        label-suffix="："
        :rules="rules"
        ref="form"
        class="createWrap"
      >
        <el-form-item
          label="受众资源名称"
          prop="name"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入受众资源的名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="性别"
          prop="sex"
        >
          <AudienceSex v-model="form.genders" />
        </el-form-item>
        <el-form-item label="年龄">
          <AudienceAge v-model="form.ageRange" />
        </el-form-item>
        <el-form-item label="自定义细分受众">
          <CustomAudience
            ref="customAudience"
            :currentAccount="currentAccount"
            :defaultList="constData.customAudienceList"
            :audienceData="audienceData"
            v-model="form.customAudiences"
          />
        </el-form-item>
        <el-form-item label="兴趣和详细受众">
          <InterestAudience
            ref="interestAudience"
            v-model="form.userInterests"
            :list="interestList"
            :interestLabelSaveAPI="interestLabelSaveAPI"
            :defaultList="constData.interestLabelQueryList"
            :accountId="currentAccount?.id"
            :defaultExpandAll="false"
            :disabled="false"
            @input="(v) => getInterest(v)"
          ></InterestAudience>
          <el-button
            v-if="productId"
            type="text"
            @click="showRecommendDialog = true"
            class="mt-1"
          >兴趣词推荐</el-button>
        </el-form-item>
        <el-form-item label="您的数据">
          <YourData
            ref="yourData"
            v-model="form.userLists"
            :currentAccount="currentAccount"
            :data="data"
            :isEdit="isEdit"
            :disabled="false"
          />
        </el-form-item>
        <el-form-item label="相似受众">
          <LikeAudience
            ref="likeAudience"
            v-model="form.lookalikeUserLists"
            :currentAccount="currentAccount"
            :data="data"
            :audienceData="audienceData"
            :isEdit="isEdit"
            :enumConstants="enumConstants"
            :disabled="false"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="sure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <RecommendAudience
      :visible.sync="showRecommendDialog"
      :productId="productId"
      :productName="productName"
      :interestList="interestList"
      :selectedIds="form.userInterests || []"
      @confirm="handleRecommendConfirm"
    />
    <CheckAudienceGroup
      :checkAudienceShow.sync="checkAudienceShow"
      :checkAudienceAdsList="checkAudienceAdsList"
      :audienceName="form.name"
      @createAudience="createAudience"
    />
  </div>
</template>
<script>
import { saveCommonInterests, createOrUpdateAudience, getUsedAdInfos } from '@/api/google/create';
import { sexList, interestList } from '../../../index';
import InterestAudience from '@/views/google/create/components/audience/interestAudiences/index';
import AudienceAge from '@/views/google/create/components/audience/AudienceAge/index.vue';
import AudienceSex from '@/views/google/create/components/audience/AudienceSex/index.vue';
import CustomAudience from '@/views/google/create/components/audience/CustomAudience/index';
import CheckAudienceGroup from '@/views/google/create/components/audience/CheckAudienceGroup/index';
import YourData from '@/views/google/create/components/audience/YourData/index.vue';
import LikeAudience from '@/views/google/create/components/audience/LikeAudience/index.vue';
import RecommendAudience from '@/views/google/create/components/audience/interestAudiences/RecommendAudience.vue';

export default {
  props: {
    createAudienceGroupDialogVisible: {
      type: Boolean,
      default: false,
    },
    currentAccount: {
      type: Object,
      default: () => {},
    },
    constData: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
    currentAudience: {
      type: Object,
      default: () => ({}),
    },
    interestList: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    audienceData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    InterestAudience,
    AudienceAge,
    AudienceSex,
    CustomAudience,
    CheckAudienceGroup,
    YourData,
    LikeAudience,
    RecommendAudience,
  },
  data() {
    return {
      form: {
        ageRange: {
          minAge: 18,
          maxAge: null,
          undetermined: true,
        }, //年龄
        genders: ['UNDETERMINED', 'MALE', 'FEMALE'], // 性别
        interests: [], // 兴趣词
        customAudience: [], // 自定义受众
        resourceName: '', //资源名称
        name: '',
        userLists: [], //您的数据
        lookalikeUserLists: [], //相似受众
      },
      sexList, //性别遍历数据
      interestLabelSaveAPI: saveCommonInterests,
      rules: {
        name: [{ required: true, message: '受众群体名称必填' }],
      },
      checkAudienceShow: false,
      checkAudienceAdsList: [],
      createParams: {},
      showRecommendDialog: false,
    };
  },
  computed: {
    title() {
      if (this.type == 'edit') {
        return '编辑';
      }
      if (this.type == 'copy') {
        return '复制';
      }
      if (this.type == 'create') {
        return '创建';
      }
    },
    productId() {
      return this.data?.promoteInfo?.sale?.productId || '';
    },
    productName() {
      return this.data?.promoteInfo?.sale?.productName || '';
    },
  },
  methods: {
    async openInit() {
      this.form = {
        ...this.currentAudience,
        resourceName: this.type == 'copy' ? '' : this.currentAudience.resourceName,
      };
      console.log(this.currentAudience);
      this.$refs.form.clearValidate();
      await this.$refs.interestAudience?.getInterestLabelQueryList();
      await this.$refs.customAudience?.getCustomAudienceList();
      await this.$refs.yourData?.getYourDataList();
      await this.$refs.likeAudience?.getLookalikeList();
    },
    close() {
      this.form = {};
      this.$emit('update:createAudienceGroupDialogVisible', false);
    },
    createAudience(params) {
      createOrUpdateAudience({ ...this.createParams, ...params }).then((res) => {
        this.$hideLoading();
        if (res.code == 0) {
          this.$emit('update:createAudienceGroupDialogVisible', false);
          this.$emit('getAudienceGroupList', res.data.googleAudience.resourceName);
        }
      });
    },
    getInterest() {},
    // 推荐受众确认回调
    handleRecommendConfirm(ids) {
      const currentIds = this.form.userInterests || [];
      this.$set(this.form, 'userInterests', [...new Set([...currentIds, ...ids])]);
    },
    sure() {
      this.$refs.form.validate(async (validator) => {
        if (validator) {
          let params = {
            accountId: this.currentAccount.id,
            ...this.form,
          };
          this.createParams = { ...params };
          this.$showLoading();
          if (this.type == 'edit') {
            let res = await getUsedAdInfos(params);
            console.log(res);
            // return;
            if (res.data && res.data.length) {
              this.checkAudienceShow = true;
              this.checkAudienceAdsList = res.data;
              this.$hideLoading();
            } else {
              this.createAudience();
            }
          } else {
            this.createAudience();
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
